import React from "react";
import ControlPanel from "./ControlPanel";
import useControlAttribute from "../../hooks/useControlAttribute";
import useModeColor from "../../hooks/useModeColor";
import ToggleIconLink from "../../Components/ToggleIconLink";
import { IControlClimate } from "./types";

interface IControlClimateProps {
  control: IControlClimate;
}

const ControlClimate = (props: IControlClimateProps) => {
  const { control } = props;
  const temperature = useControlAttribute(control, "temp_dht22");
  const mode = control.is_enabled ? "on" : "disabled";
  const iconColor = useModeColor(mode);

  return (
    <ControlPanel
      id={control.id}
      mode={mode}
      title={control.name}
      state={`${temperature}°C`}
    >
      <ToggleIconLink
        to={`/controls/details/${control.id}`}
        name="thermometer"
        color={iconColor}
      />
    </ControlPanel>
  );
};

export default ControlClimate;
